import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 56B32490-2AEB-4EF7-B0F8-72D918829BE2
 * name square-rounded
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-rounded.svg
 * tags
 */
export const SquareRoundedIcon = createSvgIcon(<><path d="M8 3H16C18.76 3 21 5.24 21 8V16C21 18.76 18.76 21 16 21H8C5.24 21 3 18.76 3 16V8C3 5.24 5.24 3 8 3Z" /></>, 'SquareRoundedIcon');
export default SquareRoundedIcon